var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "cancelation", title: "Cancelation & Termination" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You are solely responsible for properly canceling your account. You can cancel your account at any time by emailing\n        "
              ),
              _c(
                "a",
                {
                  attrs: { href: "mailto:hello@fontawesome.com" },
                  on: {
                    click: function ($event) {
                      return _vm.supportLinkClicked(
                        "tos_view",
                        "cancelation_section"
                      )
                    },
                  },
                },
                [_vm._v("hello@fontawesome.com")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        All of your Content will be immediately deleted from the Service upon cancelation. This information can not be recovered once your account is\n        canceled.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa3 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Font Awesome, in its sole discretion, has the right to suspend or terminate your account and refuse any and all current or future use of the Service,\n        or any other Font Awesome service, for any reason at any time. Such termination of the Service will result in the deactivation or deletion of your\n        Account or your access to your Account, and the forfeiture and relinquishment of all Content in your Account. Font Awesome reserves the right to\n        refuse service to anyone for any reason at any time.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v6.regular.fa4 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        In the event that Font Awesome takes action to suspend or terminate an account, we will make a reasonable effort to provide the affected account owner\n        with a copy of their account contents upon request, unless the account was suspended or terminated due to unlawful conduct.\n      "
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }